import { mapGetters, mapActions } from 'vuex'

export const signupActions = {
  ...mapActions('signupWizard', [
    'checkAvisoPrivacidad',
    'checkCondicionesServicio',
    'goNext',
    'goBack',
    'setUserPassword',
    'setInfoAdicional',
    'setTipoSuscripcion',
    'setDatosFiscales',
    'loadNoticeOfPrivacy',
    'loadTermsAndConditions',
    'signAccountDocuments',
    'markOnlySignDocs'
  ])
}

export const signupData = {
  ...mapGetters('signupWizard', [
    'avisoPrivacidad',
    'condicionesServicio',
    'canGoNext',
    'wizardStep',
    'wizardLength',
    'tipoSuscripcion',
    'account',
    'noticeOfPrivacityUrl',
    'numPagesNotice',
    'termsAndConditionsUrl',
    'numPagesTerms',
    'onlySignDocs'
  ])
}
